/* eslint-disable sort-keys */

/**
 * Export `userType`.
 */

export const userType = {
  particular: 'particular',
  professional: 'professional',
  reseller: 'reseller'
} as const;

/**
 * Export `userProfessionalType`.
 */

export const userProfessionalType = {
  agent: 'agent',
  architect: 'architect',
  builder: 'builder',
  civilEngineer: 'civil engineer',
  contractor: 'contractor',
  decorator: 'decorator',
  designer: 'designer',
  draftsman: 'draftsman',
  equipmentDesigner: 'equipment designer',
  industrialDesigner: 'industrial designer',
  interiorDesigner: 'interior designer',
  realEstateBroker: 'real estate broker',
  retailer: 'retailer',
  tilerLayer: 'tiler/layer',
  other: 'other'
} as const;

/**
 * Export `userJobTitle`.
 */

export const userJobTitle = {
  managingDirector: 'managing director',
  shopManager: 'shop manager',
  reception: 'reception',
  salesRep: 'sales rep',
  other: 'other'
} as const;
